import React, { FC } from 'react';
import { FeedbackQuestion } from './constants';
import { RatingScale, RatingValueInline } from './Rating';
import { Scores } from './types';

const LABEL = 'block text-[14.5px] font-semibold text-text-1 mb-3 leading-[1.45]';

interface Props {
    questions: FeedbackQuestion[];
    scores: Scores;
    commentLabel: string;
    commentPlaceholder: string;
    comment: string;
    onScore: (field: string, value: number) => void;
    onComment: (value: string) => void;
    readOnly?: boolean;
}

export const QuestionList: FC<Props> = ({
    questions,
    scores,
    commentLabel,
    commentPlaceholder,
    comment,
    onScore,
    onComment,
    readOnly,
}) => (
    <div className={readOnly ? 'flex flex-col' : 'flex flex-col gap-[22px]'}>
        {questions.map((question) =>
            readOnly ? (
                <div
                    key={question.field}
                    className="flex items-center justify-between gap-4 py-2.5 border-b border-border-token last:border-b-0"
                >
                    <span className="text-[13.5px] text-text-1 leading-[1.45]">
                        {question.text}
                    </span>
                    <RatingValueInline value={scores[question.field] ?? null} />
                </div>
            ) : (
                <div key={question.field}>
                    <label className={LABEL}>{question.text}</label>
                    <RatingScale
                        value={scores[question.field] ?? null}
                        left={question.lowLabel}
                        right={question.highLabel}
                        onChange={(value) => onScore(question.field, value)}
                    />
                </div>
            ),
        )}
        <div className={readOnly ? 'mt-3.5' : ''}>
            <label className={LABEL}>{commentLabel}</label>
            {readOnly ? (
                <p className="text-[13.5px] leading-[1.55] whitespace-pre-line px-3 py-2.5 rounded-[9px] border border-border-token bg-[#FAFAF8] dark:bg-surface-2 text-text-1">
                    {comment || <span className="text-[#B5AFA5] dark:text-muted italic">No comments</span>}
                </p>
            ) : (
            <textarea
                className="w-full px-3.5 py-3 border border-border-token rounded-[11px] text-[14px] text-text-1 bg-surface-2 leading-[1.5] outline-none resize-y placeholder:text-muted focus:border-accent focus:bg-surface"
                rows={3}
                placeholder={readOnly ? '' : commentPlaceholder}
                value={comment}
                readOnly={readOnly}
                onChange={(e) => onComment(e.target.value)}
            />
            )}
        </div>
    </div>
);
